import { Controller } from "@hotwired/stimulus"

// Cosmetics inventory tap-to-equip (#384).
//
// Web mirror of the mobile inventory screen. Each card carries
// `data-slot` + `data-instance-id`. Tapping a card PATCHes
// /inventory/equip with `{ slot, instance_id }` asking for a Turbo
// Stream; the server routes the equip through Cosmetics::EquipService
// (ownership / kind / lock checked, IDOR-safe) and returns a
// `turbo_stream.replace` of the tapped kind's section, so the active
// marker is server-authoritative — no optimistic client cloning.
//
// Tap semantics (matches mobile): tapping the equipped card sends an
// empty instance_id to unequip the slot; tapping any other card equips
// it. The controller derives "is this the equipped card?" from the
// `aria-pressed` attribute the server stamps on render.
//
// A mutation guard rejects taps while a request is in flight so rapid
// double-taps cannot stack writes against the section that is about to
// be swapped.
export default class extends Controller {
  static values = { url: String, token: String }

  connect() {
    this.pending = false
  }

  tap(event) {
    event.preventDefault()
    if (this.pending) return

    const btn = event.currentTarget
    if (btn.disabled) return

    const slot = btn.dataset.slot
    const instanceId = btn.dataset.instanceId || ""
    const alreadyEquipped = btn.getAttribute("aria-pressed") === "true"

    // Tapping the equipped card clears the slot; otherwise equip this one.
    const targetId = alreadyEquipped ? "" : instanceId

    this._save(slot, targetId)
  }

  _save(slot, instanceId) {
    this.pending = true

    const formData = new FormData()
    formData.append("slot", slot)
    formData.append("instance_id", instanceId)

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": this.tokenValue,
        Accept: "text/vnd.turbo-stream.html"
      },
      body: formData
    })
      .then(response => (response.ok ? response.text() : Promise.reject(response)))
      .then(html => Turbo.renderStreamMessage(html))
      .catch(() => {
        // Persistence is server-authoritative. On a transient failure the
        // section is left as-is; the next navigation re-renders from the
        // stored equipped_*_instance_id columns.
      })
      .finally(() => {
        this.pending = false
      })
  }
}
